// Persisted cookie-consent decision.
//
// Only *analytics* cookies are non-essential and therefore gated behind this
// decision. The authentication (JWT) cookie is strictly necessary — it is what
// keeps the user logged in — so it is always allowed and is NOT governed here.
const KEY = 'cookie_consent'

export const CONSENT = { GRANTED: 'granted', DENIED: 'denied' }

// Returns 'granted' | 'denied' | null (null = user has not decided yet).
export const getConsent = () => {
  try { return localStorage.getItem(KEY) } catch { return null }
}

export const setConsent = (value) => {
  try { localStorage.setItem(KEY, value) } catch { /* storage unavailable — ignore */ }
}

// Lets the user withdraw/change a previous choice as easily as they gave it
// (required for GDPR). Clears the decision and notifies the banner to re-appear.
const listeners = new Set()

export const onConsentReset = (fn) => {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export const resetConsent = () => {
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
  listeners.forEach((fn) => fn())
}
